import React from "react";
import { formatNumber, pluralize } from "@wrstudios/utils";
import { IllustrationBath, IllustrationBed, IllustrationHomeSize, IllustrationYearBuilt, IllustrationGarage, IllustrationLotSize } from "@wrstudios/illustrations";
import { Grid, Cell, Highlight, Illustration, Details, Title, Value, Difference } from "./styled/listing-highlights";
function ListingHighlights(_a) {
    var _b = _a.primaryBeds, primaryBeds = _b === void 0 ? 0 : _b, _c = _a.primaryBaths, primaryBaths = _c === void 0 ? 0 : _c, _d = _a.primarySqft, primarySqft = _d === void 0 ? 0 : _d, _e = _a.primaryGarages, primaryGarages = _e === void 0 ? 0 : _e, _f = _a.primaryYearBuilt, primaryYearBuilt = _f === void 0 ? 0 : _f, _g = _a.primaryLotSize, primaryLotSize = _g === void 0 ? 0 : _g, _h = _a.secondaryBeds, secondaryBeds = _h === void 0 ? 0 : _h, _j = _a.secondaryBaths, secondaryBaths = _j === void 0 ? 0 : _j, _k = _a.secondarySqft, secondarySqft = _k === void 0 ? 0 : _k, _l = _a.secondaryGarages, secondaryGarages = _l === void 0 ? 0 : _l, _m = _a.secondaryYearBuilt, secondaryYearBuilt = _m === void 0 ? 0 : _m, _o = _a.secondaryLotSize, secondaryLotSize = _o === void 0 ? 0 : _o, _p = _a.hasAcres, hasAcres = _p === void 0 ? false : _p;
    var diffBeds = secondaryBeds - primaryBeds;
    var diffBaths = secondaryBaths - primaryBaths;
    var diffSqft = ((secondarySqft - primarySqft) / secondarySqft) * 100;
    var diffYearBuilt = secondaryYearBuilt - primaryYearBuilt;
    var diffGarages = secondaryGarages - primaryGarages;
    var diffAcres = ((secondaryLotSize - primaryLotSize) / secondaryLotSize) * 100;
    var hasBedsComparison = Boolean(primaryBeds && secondaryBeds);
    var hasBathsComparison = Boolean(primaryBaths && secondaryBaths);
    var hasSqftComparison = Boolean(primarySqft && secondarySqft);
    var hasYearBuiltComparison = Boolean(primaryYearBuilt && secondaryYearBuilt);
    var hasGaragesComparison = Boolean(primaryGarages && secondaryGarages);
    var hasAcresComparison = Boolean(primaryLotSize && secondaryLotSize);
    return (React.createElement(Grid, null,
        !!primaryBeds && (React.createElement(Cell, null,
            React.createElement(Highlight, null,
                React.createElement(Illustration, null,
                    React.createElement(IllustrationBed, null)),
                React.createElement(Details, null,
                    React.createElement(Title, null,
                        "Bedrooms",
                        hasBedsComparison && (React.createElement(Difference, { value: diffBeds }, diffBeds < 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2191 ",
                            formatNumber(diffBeds * -1, "0[.][,][0]"))) : diffBeds > 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2193 ",
                            formatNumber(diffBeds, "0[.][,][0]"))) : null))),
                    React.createElement(Value, null, formatNumber(primaryBeds)))))),
        !!primaryBaths && (React.createElement(Cell, null,
            React.createElement(Highlight, null,
                React.createElement(Illustration, null,
                    React.createElement(IllustrationBath, null)),
                React.createElement(Details, null,
                    React.createElement(Title, null,
                        "Bathrooms",
                        hasBathsComparison && (React.createElement(Difference, { value: diffBaths }, diffBaths < 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2191",
                            " ",
                            formatNumber(diffBaths * -1, "0[.][,][0]"))) : diffBaths > 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2193 ",
                            formatNumber(diffBaths, "0[.][,][0]"))) : null))),
                    React.createElement(Value, null, formatNumber(primaryBaths)))))),
        !!primarySqft && (React.createElement(Cell, null,
            React.createElement(Highlight, null,
                React.createElement(Illustration, null,
                    React.createElement(IllustrationHomeSize, null)),
                React.createElement(Details, null,
                    React.createElement(Title, null,
                        "Home Size",
                        hasSqftComparison && (React.createElement(Difference, { value: diffSqft },
                            Math.abs(diffSqft) >= 0.1 && (React.createElement(React.Fragment, null, diffSqft < 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2191 ",
                                formatNumber(diffSqft * -1, "0[,]0"),
                                "%")) : diffSqft > 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2193 ",
                                formatNumber(diffSqft, "0[,]0"),
                                "%")) : null)),
                            Math.abs(diffSqft) < 0.1 && (React.createElement(React.Fragment, null, diffSqft < 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2191 ",
                                formatNumber(diffSqft * -1, "0.0[0]"),
                                "%")) : diffSqft > 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2193 ",
                                formatNumber(diffSqft, "0.0[0]"),
                                "%")) : null))))),
                    React.createElement(Value, null,
                        formatNumber(primarySqft),
                        " sq. ft."))))),
        !!primaryYearBuilt && (React.createElement(Cell, null,
            React.createElement(Highlight, null,
                React.createElement(Illustration, null,
                    React.createElement(IllustrationYearBuilt, null)),
                React.createElement(Details, null,
                    React.createElement(Title, null,
                        "Year Built",
                        hasYearBuiltComparison && (React.createElement(Difference, { value: diffYearBuilt }, diffYearBuilt < 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2191 ",
                            formatNumber(diffYearBuilt * -1, "0[,]0"),
                            " ",
                            pluralize("yrs", Math.abs(diffYearBuilt)))) : diffYearBuilt > 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2193 ",
                            formatNumber(diffYearBuilt, "0[,]0"),
                            " ",
                            pluralize("yrs", Math.abs(diffYearBuilt)))) : null))),
                    React.createElement(Value, null, primaryYearBuilt))))),
        !!primaryGarages && (React.createElement(Cell, null,
            React.createElement(Highlight, null,
                React.createElement(Illustration, null,
                    React.createElement(IllustrationGarage, null)),
                React.createElement(Details, null,
                    React.createElement(Title, null,
                        "Garages",
                        hasGaragesComparison && (React.createElement(Difference, { value: diffGarages }, diffGarages < 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2191",
                            " ",
                            formatNumber(diffGarages * -1, "0[.][,][0]"))) : diffGarages > 0 ? (React.createElement(React.Fragment, null,
                            "\u00A0\u2193 ",
                            formatNumber(diffGarages, "0[.][,][0]"))) : null))),
                    React.createElement(Value, null, primaryGarages))))),
        !!primaryLotSize && (React.createElement(Cell, null,
            React.createElement(Highlight, null,
                React.createElement(Illustration, null,
                    React.createElement(IllustrationLotSize, null)),
                React.createElement(Details, null,
                    React.createElement(Title, null,
                        "Lot Size",
                        hasAcresComparison && (React.createElement(Difference, { value: diffAcres },
                            Math.abs(diffAcres) >= 0.1 && (React.createElement(React.Fragment, null, diffAcres < 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2191 ",
                                formatNumber(diffAcres * -1, "0[,]0"),
                                "%")) : diffAcres > 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2193 ",
                                formatNumber(diffAcres, "0[,]0"),
                                "%")) : null)),
                            Math.abs(diffAcres) < 0.1 && (React.createElement(React.Fragment, null, diffAcres < 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2191",
                                " ",
                                formatNumber(diffAcres * -1, "0.0[0]"),
                                "%")) : diffAcres > 0 ? (React.createElement(React.Fragment, null,
                                "\u00A0\u2193 ",
                                formatNumber(diffAcres, "0.0[0]"),
                                "%")) : null))))),
                    React.createElement(Value, null,
                        formatNumber(primaryLotSize, "0[,][.]0[0]"),
                        hasAcres ? React.createElement(React.Fragment, null, "\u00A0acres") : null)))))));
}
export default ListingHighlights;
